// @flow
import { YES_ECO_TARIFF, NO_ECO_TARIFF } from "./constants";
import { CategoryTypes } from "Commons/Modules/category";
import type { ShortReminderT } from "../misc/Types";
import type { ReminderT } from "../../Reminder/misc/Types";

export function normalizeData(data: ReminderT): ShortReminderT {
  const greenPowerFieldSet = "gasDesiredGreenPower" in data || "electricityDesiredGreenPower" in data;
  const greenPowerFieldName: string =
    data.category === CategoryTypes.GAS ? "gasDesiredGreenPower" : "electricityDesiredGreenPower";
  let greenPowerFieldValue;
  if (data[greenPowerFieldName] === YES_ECO_TARIFF) greenPowerFieldValue = true;
  if (data[greenPowerFieldName] === NO_ECO_TARIFF) greenPowerFieldValue = false;
  if (data[greenPowerFieldName] !== NO_ECO_TARIFF && data[greenPowerFieldName] !== YES_ECO_TARIFF)
    greenPowerFieldValue = data[greenPowerFieldName];
  const consumptionFieldName: string =
    "electricityYearlyConsumption" in data ? "electricityYearlyConsumption" : "gasYearlyConsumption";
  return {
    onBehalfOf: data.onBehalfOf,
    propertyType: data.propertyType,
    postalcode: data.postalcode,
    location: data.location,
    locationId: data.locationId,
    locationMainName: data.locationMainName,
    locationPartName: data.locationPartName,
    companyId: data.companyId,
    companyName: data.companyName,
    categoryId: data.categoryId,
    category: data.category,
    categoryProviderId: data.categoryProviderId,
    tariffId: data.tariffId,
    tariffName: data.tariffName,
    permanentTariffId: data.permanentTariffId,
    shortOffer: true,
    latestDeviceMetadata: data.latestDeviceMetadata,
    [consumptionFieldName]: data[consumptionFieldName],
    ...(greenPowerFieldSet ? { [greenPowerFieldName]: greenPowerFieldValue } : { [greenPowerFieldName]: false }),
  };
}
